import React, { useEffect, useState } from "react";

import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  PhotoIcon,
  UserCircleIcon,
} from "@heroicons/react/24/solid";
import LogoBranca from "../assets/logo_branca.png";
import Loader from "../components/spinner";
import Dialog from "../components/dialog";
import { Button } from "rsuite";

export default function Inscricao(props) {
  const { Logo, bgColor, pageTitle, parcelas } = props;
  const [ingresso, setIngresso] = useState(null);
  const [cpf, setCpf] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [dataDeNascimento, setDataDeNascimento] = useState("");
  const [fkGenero, setFkGenero] = useState(null);
  const [fkRaca, setFkRaca] = useState(null);
  const [portadorEspecial, setPortadorEspecial] = useState(0);
  const [fkFormaDePagamento, setFkFormaDePagamento] = useState(2);
  const { fkCongresso } = props;

  const [cep, setCep] = useState("");
  const [bairro, setBairro] = useState("");
  const [uf, setUf] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [telefone, setTelefone] = useState("");
  const [fkTipoDeficiencia, setFkTipoDeficiencia] = useState(null);

  const [generos, setGeneros] = useState([]);
  const [racas, setRacas] = useState([]);

  const [tipoDeficiencias, setTipoDeficiencias] = useState([]);

  const [openLoader, setOpenLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [icon, setIcons] = useState(null);
  const [message, setMessage] = useState(null);
  const [buttons, setButtons] = useState(null);
  const [termoDeAceite, setTermoDeAceite] = useState(false);

  const [nomeImpressoNoCartao, setNomeImpressoNoCartao] = useState("");
  const [numeroDoCartao, setNumeroDoCartao] = useState("");
  const [bandeiraDoCartao, setBandeiraDoCartao] = useState("");
  const [validadeDoCartao, setValidadeDoCartao] = useState("");
  const [cvc, setCVC] = useState("");

  const [voucher, setVoucher] = useState('');
  const [voucherValidado, setVoucherValidado] = useState(null);
  
  const [parcelado, setParcelado] = useState(false);
  const [numeroDeParcelas, setNumeroDeParcelas] = useState(null);
  const [voucherPromocional, setVoucherPromocional] = useState('');
  const [ativarPromocao, setAtivarPromocao] = useState(false);
  const [ingressos, setIngressos] = useState([]);
  const [aluno, setAluno] = useState(false);

  const formatCpf = (value) => {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  };

  const formatFone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "($1) $2 ");
    value = value.replace(/(\d)(\d{4})$/, "$1-$2");
    return value;
  };

  const removeMask = (value) => value.replace(/\D/g, "");

  function format(value) {
    let negativo = value < 0;

    value = parseFloat(value)
      .toFixed(2)
      .toString()
      .replace("-", "")
      .split(".");

    value[0] =
      `${negativo ? "-" : ""}R$ ` + value[0].split(/(?=(?:...)*$)/).join(".");
    return value.join(",");
  }

  const maskCreditCardNumber = (creditCardNumber) => {
    creditCardNumber = creditCardNumber.replace(/\D/g, "");
    creditCardNumber = creditCardNumber.replace(/^(\d{4})(\d)/, "$1 $2");
    creditCardNumber = creditCardNumber.replace(
      /^(\d{4})\ (\d{4})(\d)/,
      "$1 $2 $3"
    );
    creditCardNumber = creditCardNumber.replace(
      /^(\d{4})\ (\d{4})\ (\d{4})(\d)/,
      "$1 $2 $3 $4"
    );
    return creditCardNumber;
  };

  const maskCreditCardExpireDate = (value) => {
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{2})(\d)/, "$1/$2");

    return value;
  };

  function carregarDadosInscritos(value) {
    if (value) {
      setOpenLoader(true);
      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/pessoa/dadosdoinscrito?cpf=${value}`,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((response) => {
          setOpenLoader(false);
          const { data } = response;

          setNome(data.nome);
          setEmail(data.email);
          setDataDeNascimento(data.dataNascimento);
          setFkGenero(data.fkGenero);
          setFkRaca(data.fkRaca);
          setCep(data.cep);
          setLogradouro(data.logradouro);
          setNumero(data.numero);
          setComplemento(data.complemento);
          setBairro(data.bairro);
          setCidade(data.cidade);
          setEstado(data.uf);
          setTelefone(data.fone1);
          setPortadorEspecial(data.portadorEspecial);
          setAluno(data.aluno);
        })
        .catch((err) => {
          setOpenLoader(false);
        });
    }
  }

  function carregarGenero() {
    setOpenLoader(true);
    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/pessoa/genero/`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        const { data } = response;
        setGeneros(data);
        carregarRaca();
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  }

  function carregarRaca() {
    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/informacao/raca/`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        const { data } = response;
        setRacas(data);
        carregarTipoDeficiencia();
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  }

  function carregarTipoDeficiencia() {
    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/pessoa/tipodeficiencia/`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        const { data } = response;
        setTipoDeficiencias(data);
        carregarValorInscricao();
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  }

  function carregarValorInscricao() {
    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/inscricao/ingresso/?fkCongresso=${fkCongresso}`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => { 
        const { data } = response;
        setIngressos(data);
        setIngresso(data[0])
        setOpenLoader(false);
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  }

  function buscarCep(value) {
    if (value) {
      setOpenLoader(true);
      const cepFormatado = value.replace(".", "").replace("-", "");
      let request = new XMLHttpRequest();
      request.open(
        "GET",
        "https://viacep.com.br/ws/" + cepFormatado + "/json/"
      );
      request.addEventListener("load", (e) => {
        setOpenLoader(false);
        let endereco = JSON.parse(e.target.responseText);
        if (endereco.erro === undefined) {
          setBairro(endereco.bairro);
          setCidade(endereco.localidade);
          setLogradouro(endereco.logradouro);
          setUf(endereco.uf.toUpperCase());
          setEstado(endereco.uf.toUpperCase());
          // setfkPais(35);
        }
      });
      request.send();
    }
  }

  function handleVoucher(value) {
    setVoucher(value.toUpperCase());

    if (value.length >= 8) {
      setOpenLoader(true);

      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/voucher/${value}/valid?fkCongresso=${fkCongresso}`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((response) => {
          const { data } = response;
          // setIngresso(data);
          setVoucherValidado(response)
          setOpenLoader(false);
        })
        .catch((err) => {
          setOpenLoader(false);
        });
    } else {
      setVoucherValidado(null)
    }
  }

  function handleVoucherPromocional(e) {
    setVoucherPromocional(e.target.value.trim().toUpperCase());
    if(ingresso.cupomDeDesconto.trim().toUpperCase()) {
      if (e.target.value.trim().toUpperCase() === ingresso.cupomDeDesconto.trim().toUpperCase()) {
        setAtivarPromocao(true)
      } else {
        setAtivarPromocao(false)
      }
    }
  }

  useEffect(() => {
    document.title = pageTitle
    carregarGenero();
  }, []);

  const finalizarInscricao = () => {
    // const token = window.grecaptcha.getResponse();
    setOpenLoader(true);

      const body = {
        cpf,
        nome,
        email,
        dataDeNascimento,
        fkGenero,
        fkRaca,
        cep,
        logradouro,
        numero,
        complemento,
        bairro,
        cidade,
        estado,
        telefone,
        portadorEspecial,
        fkTipoDeficiencia,
        termoDeAceite,
        token: null,
        nomeImpressoNoCartao,
        numeroDoCartao,
        bandeiraDoCartao,
        validadeDoCartao,
        cvc,
        voucher,
        fkFormaDePagamento,
        fkCongresso,
        parcelado,
        numeroDeParcelas,
        cupomDeDesconto: voucherPromocional,
        fkInscricaoValor: ingresso.fkInscricaoValor
      };

      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/inscricao/inscricao/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(body),
      }).then((response) =>
        response.json().then((data) => {
          const { message } = data;
          setOpenLoader(false);
          setTitle("Atenção");
          setOpen(true);
          setMessage(message);
          if (response.status === 200) {
            setIcons(
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                <CheckCircleIcon
                  className="h-6 w-6 text-green-600"
                  aria-hidden="true"
                />
              </div>
            );
            setButtons(
              <>
                <button
                  type="button"
                  className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
                  onClick={() => window.location.reload()}
                >
                  OK
                </button>
              </>
            );
          } else {
            // window.grecaptcha.reset();
            setIcons(
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <ExclamationTriangleIcon
                  className="h-6 w-6 text-red-600"
                  aria-hidden="true"
                />
              </div>
            );
            setButtons(
              <>
                <button
                  type="button"
                  className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  onClick={() => setOpen(false)}
                >
                  Corrigir
                </button>
              </>
            );
          }
        })
      );
    // if (token.length > 0) {
      
    // }
  };

  const handleCpfChange = (e) => {
    setCpf(removeMask(e.target.value));

    setNome('');
    setEmail('');
    setDataDeNascimento('');
    setFkGenero('');
    setFkRaca('');
    setCep('');
    setLogradouro('');
    setNumero('');
    setComplemento('');
    setBairro('');
    setCidade('');
    setEstado('');
    setTelefone('');
    setPortadorEspecial(0);
    setAluno(0);
  }

  return (
    <div className="absolute left-0 right-0 bottom-0 top-0 bg-slate-100 overflow-x-hidden overflow-y-scroll flex flex-col items-center">
      <header className="h-[64px] min-h-[64px] bg-slate-800 text-slate-100 font-bold flex flex-row items-center justify-center w-full">
        <img src={LogoBranca} alt="SENAC Pernambuco" className="h-[56px]" />
      </header>
      <div className="p-8 m-4 w-full self-center bg-white border border-slate-200 rounded-md font-normal text-sm shadow-[0px_0px_35px_0px_rgba(154,161,171,0.15)] lg:w-[900px]">
        <form>
          <div className={`${bgColor} flex flex-col items-center justify-center text-white rounded mb-16`}>
            <img src={Logo} />
          </div>
          <div className="space-y-12">
            <div className="pb-12">
              <div className="flex flex-row items-start justify-start pb-4 mb-4 border-b border-gray-900/10">
                <h3 className="text-base font-bold text-[20px] leading-7 text-gray-800">
                  DADOS DO INSCRITO
                </h3>
              </div>
              <p className="mt-1 text-sm leading-6 text-gray-600">
                <Loader open={openLoader} />
                <Dialog
                  title={title}
                  icon={icon}
                  open={open}
                  message={message}
                  buttons={buttons}
                />
                {/* Use a permanent address where you can receive mail. */}
              </p>
              <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <div className="sm:col-span-3">
                  <label
                    htmlFor="first-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    CPF
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="cpf"
                      id="cpf"
                      autoComplete="given-name"
                      value={formatCpf(cpf)}
                      onChange={(e) => handleCpfChange(e)}
                      maxLength={14}
                      onBlur={(e) =>
                        carregarDadosInscritos(removeMask(e.target.value))
                      }
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Nome
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="nome"
                      id="nome"
                      autoComplete="family-name"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="first-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    E-mail
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="email"
                      id="email"
                      autoComplete="given-name"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Data de Nascimento
                  </label>
                  <div className="mt-2">
                    <input
                      type="date"
                      name="dataNascimento"
                      id="dataNascimento"
                      autoComplete="family-name"
                      value={dataDeNascimento}
                      onChange={(e) => setDataDeNascimento(e.target.value)}
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* <div className="sm:col-span-4">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Email address
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div> */}

                <div className="sm:col-span-3">
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Gênero
                  </label>
                  <div className="mt-2">
                    <select
                      id="country"
                      name="country"
                      autoComplete="country-name"
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={fkGenero}
                      onChange={(e) =>
                        setFkGenero(
                          e.target.options[e.target.selectedIndex].value
                        )
                      }
                    >
                      <option></option>
                      {generos.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.tipo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Qual a sua Raça?
                  </label>
                  <div className="mt-2">
                    <select
                      id="country"
                      name="country"
                      autoComplete="country-name"
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={fkRaca}
                      onChange={(e) =>
                        setFkRaca(
                          e.target.options[e.target.selectedIndex].value
                        )
                      }
                    >
                      <option></option>
                      {racas.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-span-full">
                  <label
                    htmlFor="street-address"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    CEP
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="cep"
                      id="cep"
                      autoComplete="cep"
                      value={cep}
                      onChange={(e) => setCep(e.target.value)}
                      onBlur={(e) => buscarCep(e.target.value)}
                      maxLength={8}
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div className="sm:col-span-2 sm:col-start-1">
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Logradouro
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="logradouro"
                      id="logradouro"
                      autoComplete="logradouro"
                      className="block w-full pl-2 pr-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={logradouro}
                      onChange={(e) => setLogradouro(e.target.value)}
                    />
                  </div>
                </div>

                <div className="sm:col-span-2">
                  <label
                    htmlFor="region"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Número
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="numero"
                      id="numero"
                      autoComplete="numero"
                      className="block pl-2 pr-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={numero}
                      onChange={(e) => setNumero(e.target.value)}
                    />
                  </div>
                </div>

                <div className="sm:col-span-2">
                  <label
                    htmlFor="postal-code"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Complemento
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="complemento"
                      id="complemento"
                      autoComplete="complemento"
                      className="block w-full pr-2 pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={complemento}
                      onChange={(e) => setComplemento(e.target.value)}
                    />
                  </div>
                </div>

                <div className="sm:col-span-2 sm:col-start-1">
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Bairro
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="bairro"
                      id="bairro"
                      autoComplete="bairro"
                      className="block w-full pr-2 pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={bairro}
                      onChange={(e) => setBairro(e.target.value)}
                    />
                  </div>
                </div>

                <div className="sm:col-span-2">
                  <label
                    htmlFor="region"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Cidade
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="cidade"
                      id="cidade"
                      autoComplete="cidade"
                      className="block w-full pr-2 pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={cidade}
                      onChange={(e) => setCidade(e.target.value)}
                    />
                  </div>
                </div>

                <div className="sm:col-span-2">
                  <label
                    htmlFor="postal-code"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Estado
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="estado"
                      id="estado"
                      autoComplete="estado"
                      className="block w-full pr-2 pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={estado}
                      onChange={(e) => setEstado(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-span-full">
                  <label
                    htmlFor="street-address"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Telefone
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="telefone"
                      id="telefone"
                      autoComplete="telefone"
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      maxLength={16}
                      value={formatFone(telefone)}
                      onChange={(e) => setTelefone(removeMask(e.target.value))}
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Pessoa com Deficiência?
                  </label>
                  <div className="mt-2">
                    <select
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      value={portadorEspecial}
                      onChange={(e) => {
                        {
                          setPortadorEspecial(
                            e.target.options[e.target.selectedIndex].value
                          );
                          setFkTipoDeficiencia(null);
                        }
                      }}
                    >
                      <option value={0}>Não</option>
                      <option value={1}>Sim</option>
                    </select>
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Tipo de Deficiência
                  </label>
                  <div className="mt-2">
                    <select
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      disabled={portadorEspecial == 1 ? false : true}
                      onChange={(e) =>
                        setFkTipoDeficiencia(
                          e.target.options[e.target.selectedIndex].value
                        )
                      }
                      selectedIndex={fkTipoDeficiencia}
                    >
                      <option></option>
                      {tipoDeficiencias.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="sm:col-span-3 flex flex-row w-full">
                  <div className="flex h-6 items-center mr-4">
                    <input
                      id="candidates"
                      name="candidates"
                      type="checkbox"
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                      onChange={(e) => setTermoDeAceite(e.target.checked)}
                    />
                  </div>
                  <div className="text-sm leading-6">
                    <label htmlFor="candidates" className="text-gray-900">
                      Declaro que aceito a{" "}
                      <a
                        href="https://intranet.pe.senac.br/dr/crm/cadastrodeinteresse/senac/politica_de_privacidade/politica_de_privacidade_v1.0.pdf"
                        className="font-bold text-blue-600"
                        target="_blank"
                      >
                        Política de Privacidade
                      </a>{" "}
                      do Senac Pernambuco.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row items-start justify-start pb-4 mb-4 border-b border-gray-900/10">
            <h3 className="text-base font-bold text-[20px] leading-7 text-gray-800">
              INGRESSO
            </h3>
          </div>
          {aluno ? <div className="bg-amber-100 p-2 rounded border border-1 border-amber-300 text-neutral-950">
              <p className="text-md mb-2">🎉 <span>DESCONTO <b>ALUNO SENAC</b></span> aplicado!</p>
              <p className="text-sm">Aproveite agora essa condição exclusiva e garanta já a sua inscrição no congresso.</p>
          </div> : ''}
          {ingressos.map((item, index) => 
          <Button variante="light" className={`w-full ml-0 mr-0 mt-[8px] p-0 text-left`} onClick={() => setIngresso(item)}>
            <div key={index} className={`rounded-md font-normal text-sm shadow-[0px_0px_35px_0px_rgba(154,161,171,0.15)] ${item.fkInscricaoValor === ingresso.fkInscricaoValor ? 'border-4 border-blue-500 cursor-pointer' : 'border border-gray-200'}`}>
              <div className="flex flex-row bg-slate-800 text-slate-100 p-2 rounded-tl-[2px] rounded-tr-[2px]">
                <div className="font-bold flex-1">{item.tituloDeVendaDoTicket}</div>
                {aluno ? <div className="font-bold bg-amber-300 pl-2 pr-2 rounded text-neutral-950">
                  {item ? ativarPromocao ? format(item.valorComDesconto) : format(item.valor*0.5) : ""}
                </div> : <div className="font-bold">
                  {item ? ativarPromocao ? format(item.valorComDesconto) : format(item.valor) : ""}
                </div>}
              </div>
              <div className="flex flex-row p-2">
                <div className="flex-1">
                  {item
                    ? `${item.titulo} (${item.local}) ${format(
                      item.valor
                      )} Vendas até ${item.fimInscricao}.`
                    : ""}
                </div>
                {item ? (
                  <div>
                    {item.possuiVagas ? (
                      "1 Ingresso"
                    ) : (
                      <div className="bg-red-600 pl-4 pr-4 text-red-50 font-bold rounded">
                        Esgotado
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Button>)}
          
          <div className="flex flex-row items-start justify-start pb-4 mb-4 border-b border-gray-900/10 mt-8">
            <h3 className="text-base font-bold text-[20px] leading-7 text-gray-800">
              PAGAMENTO
            </h3>
          </div>
          <div className="col-span-full mt-8">
            <label
              htmlFor="last-name"
              className="block text-sm font-medium leading-6 text-gray-900">
              Forma de Pagamento
            </label>
            <div className="mt-2">
              <select
                className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={fkFormaDePagamento}
                onChange={(e) => {
                  {
                    console.log(e.target.options[e.target.selectedIndex].value)
                    setFkFormaDePagamento(
                      e.target.options[e.target.selectedIndex].value
                    );
                  }
                }}
              >
                <option value={2}>Cartão</option>
                <option value={3}>Empresa</option>
              </select>
            </div>
          </div>

          {fkFormaDePagamento == 2 ? 
            <div className="pt-6">

              <div className="sm:col-span-3 flex flex-row w-full">
                <div className="flex h-6 items-center mr-4 mb-[16px]">
                  <input
                    id="parcelado"
                    name="parcelado"
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    checked={parcelado}
                    onChange={(e) => {
                      setParcelado(e.target.checked)
                      if(!e.target.checked) {
                        setNumeroDeParcelas(null)
                      }
                    }}
                  />
                </div>
                <div className="text-sm leading-6">
                  <label htmlFor="parcelado" className="text-gray-900">
                    Parcelado
                  </label>
                </div>
              </div>

              <div className="col-span-full mb-8">
                <label
                  htmlFor="last-name"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Número de Parcelas
                </label>
                <div className="mt-2">
                  <select
                    className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    value={numeroDeParcelas}
                    disabled={!parcelado && ingresso}
                    onChange={(e) => {
                      {
                        console.log(e.target.options[e.target.selectedIndex].value)
                        setNumeroDeParcelas(
                          e.target.options[e.target.selectedIndex].value
                        );
                      }
                    }}
                  >
                    <option value={null}></option>
                    {parcelas.map((parcela, index) => <option value={parcela}>{ativarPromocao ? `${parcela}x R$ ${format(ingresso ? ingresso.valorComDesconto / parcela : 0)}` : `${parcela}x R$ ${format(ingresso ? ingresso.valor / parcela : 0)}`}</option>)}
                  </select>
                </div>
              </div>

              {/* <div className="col-span-full">
                <label
                  htmlFor="street-address"
                  className="block text-sm font-medium leading-6 text-gray-900">
                  Voucher Promocional
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    value={voucherPromocional}
                    onChange={handleVoucherPromocional}
                    className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
                {ativarPromocao ? <p className="text-green-500 font-medium mt-2">Cupom de desconto aplicado com sucesso!</p> : ''}
              </div> */}

              <div className="col-span-full mt-8">
                <label
                  htmlFor="street-address"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Nome Impresso no Cartão
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    value={nomeImpressoNoCartao}
                    onChange={(e) => setNomeImpressoNoCartao(e.target.value)}
                    className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              
              <div className="col-span-full mt-8">
                <label
                  htmlFor="street-address"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Número do Cartão
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    value={maskCreditCardNumber(numeroDoCartao)}
                    onChange={(e) =>
                      setNumeroDoCartao(removeMask(e.target.value))
                    }
                    maxLength={19}
                    className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="flex-1 mt-8">
                  <label
                    htmlFor="street-address"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Bandeira do Cartão
                  </label>
                  <select
                    className="block pr-2 pl-2 mt-2 h-[32px] sm:h-[36px] w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    value={bandeiraDoCartao}
                    onChange={(e) => {
                      {
                        setBandeiraDoCartao(
                          e.target.options[e.target.selectedIndex].value
                        );
                      }
                    }}
                  >
                    <option></option>
                    <option value="VISA">VISA</option>
                    <option value="MASTERCARD">MASTERCARD</option>
                    <option value="ELO">ELO</option>
                    <option value="DINERS">DINERS</option>
                    <option value="DISCOVER">DISCOVER</option>
                    <option value="AMEX">AMEX</option>
                    <option value="CREDZ">CREDZ</option>
                    <option value="JCB">JCB</option>
                    <option value="HIPER">HIPER</option>
                    <option value="HIPERCARD">HIPERCARD</option>
                  </select>
                </div>

                <div className="flex-1 mt-8 min-w-[80px]">
                  <label
                    htmlFor="street-address"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Validade
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      value={maskCreditCardExpireDate(validadeDoCartao)}
                      onChange={(e) =>
                        setValidadeDoCartao(removeMask(e.target.value))
                      }
                      maxLength={7}
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div className="flex-1 min-w-[80px] mt-8">
                  <label
                    htmlFor="street-address"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    CVC
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      value={cvc}
                      onChange={(e) => setCVC(e.target.value)}
                      maxLength={3}
                      className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

            </div> : 
            
            <div>
              <div className="col-span-full mt-8">
                <label
                  htmlFor="street-address"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Voucher
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    value={voucher}
                    onChange={(e) => handleVoucher(e.target.value)}
                    className="block pr-2 pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                  {voucherValidado ? 
                    voucherValidado.valido ? <p className="text-[12px] text-green-500">Voucher validado com sucesso!</p> : <p className="text-[12px] text-red-500">Não foi possível validar o voucher.</p>
                  : ''}
                </div>
              </div>
              
              {voucherValidado ? 
                voucherValidado.valido ? <div className="border border-slate-200 rounded-md font-normal text-sm shadow-[0px_0px_35px_0px_rgba(154,161,171,0.15)] mt-8">
                <div className="flex flex-row bg-slate-800 text-slate-100 p-2 rounded-md">
                  <div className="font-bold flex-1">Empresa</div>
                  <div className="font-bold">
                    {/* {ingresso ? format(ingresso.valor) : ""} */}
                  </div>
                </div>
                <div className="flex flex-row p-2">
                  <div className="flex-1">
                    {`${voucherValidado.data.LoteVoucher.Instituicao.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")} - ${voucherValidado.data.LoteVoucher.Instituicao.nome}`}
                  </div>
                </div>
              </div> : ''
              : ''}
            </div>
          }

          
          <div className="border-b border-gray-900/10 mt-8">
            {/* <div style={{ marginBottom: 16 }}>
              <div
                id="captcha"
                class="g-recaptcha"
                data-sitekey="6LfPtJgpAAAAAIhe95BKUtx_S-cVGGTHgi79_Nh2"
              ></div>
            </div> */}
          </div>
          <div className="mt-6 flex items-center justify-end gap-x-6">
            <div className="flex-1"></div>
            <button
              type="button"
              className="text-sm font-semibold leading-6 text-gray-900"
            >
              Cancel
            </button>
            <button
              type="button"
              className="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              onClick={finalizarInscricao}
            >
              Finalizar Inscrição
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
